/** Central SEO constants — use NEXT_PUBLIC_SITE_URL on staging/preview. */
export const SITE_URL =
  process.env.NEXT_PUBLIC_SITE_URL?.replace(/\/$/, "") || "https://salontym.com";

export const SITE_NAME = "SalonTym";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png`;

export const LOCALE = "en_IN";

export const TWITTER_HANDLE = "@salontym";

/** Human-readable label from URL slug (e.g. salon-at-home → Salon at home) */
export function humanizeSlug(slug: string): string {
  if (!slug?.trim()) return SITE_NAME;
  return slug
    .split(/[-_]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
}

export function canonicalPath(path: string): string {
  const p = path.startsWith("/") ? path : `/${path}`;
  return `${SITE_URL}${p === "//" ? "/" : p}`;
}
